/** @format */

import React from "react";
import emailjs from "emailjs-com";

import { contact, section5Title, social } from "../../profile";

const Contact = () => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ruasauk",
        "template_fksb30c",
        e.target,
        "user_SH0MzJiYXl8J6fCghbKpa"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    document.getElementById(
      "message-box"
    ).innerHTML = `<h2>Thanks! I'll reply ASAP :)</h2>`;
    console.log("hello");
    e.target.reset();
  }
  return (
    <div className="parallax">
      <div data-aos="zoom-in-up" data-aos-once="true" className="git-form">
        <>
          <div className="git-head-div text-center mx-auto">
            <h1 id="Contact" className="git-head">
              {section5Title}
            </h1>
          </div>
        </>
        <div className="container">
          <div className="git-cont row">
            <div className="col-12 col-sm-6 half">
              <form onSubmit={sendEmail}>
                <input
                  type="text"
                  id="fname"
                  name="name"
                  placeholder="Your name"
                  required></input>
                <input
                  type="mail"
                  id="mailid"
                  name="email"
                  placeholder="Email Address"
                  required></input>
                <input
                  type="text"
                  id="sub"
                  name="subject"
                  placeholder="Subject"
                  required></input>
                <textarea
                  id="msg"
                  name="message"
                  placeholder="Message"
                  required></textarea>
                {/* <button style={{ cursor: "pointer" }} type="submit">
                  Send Message
                </button> */}
                <div className="col-8 pt-3 mx-auto">
                  <input
                    required
                    type="submit"
                    className="btn btn-info"
                    value="Send Message"></input>
                </div>
              </form>
              <div class="message-box" id="message-box"></div>
            </div>
            <div className="col-12 col-sm-6 half">
              <p className="lead">{contact.pitch}</p>
              <div className="d-flex justify-content-center align-items-center flex-column">
                <div className="inline-block">
                  {social.linkedin && (
                    <a
                      title="Visit Linkedin profile"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={social.linkedin}>
                      <i className="fab fa-linkedin"></i>
                    </a>
                  )}
                  {social.facebook && (
                    <a
                      title="Visit Facebok profile"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={social.facebook}>
                      <i className="fab fa-facebook"></i>
                    </a>
                  )}
                  {social.twitter && (
                    <a
                      title="Visit Twitter profile"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={social.twitter}>
                      <i className="fab fa-twitter"></i>
                    </a>
                  )}
                  {social.instagram && (
                    <a
                      title="Visit Instagram profile"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={social.instagram}>
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}
                  {social.github && (
                    <a
                      title="Visit Github profile"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={social.github}>
                      <i className="fab fa-github"></i>
                    </a>
                  )}
                  <br />
                </div>
                {social.resume && (
                  <a title="Download Resume" href={social.resume} download>
                    <i className="fas fa-download"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <p id="not-dark" className="Copy">
        2020 © Copyright <strong>{contact.copyright}</strong>. All Rights
        Reserved
      </p>
    </div>
  );
};

export default Contact;
